var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onetushow"},[_c('div',{ref:"test",staticClass:"imgscale"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.onetuimg,"alt":""}})]),_c('span',{staticClass:"backbtn",on:{"click":function($event){return _vm.closeModel()}}},[_vm._v("返 回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }